class HistoryComponentController {
    constructor(_, dateTimeService) {
        this._ = _;
        this.historyItems = null;
        this.firstHistoryItem = null;
        this.expanded = false;
        this.formatDate = dateTimeService.formatDate;
    }

    $onInit() {
        if (this.history && this.history.length) {
            this.historyItems = this._.map(this.history, (historyItem) => ({
                date: this.formatDate(historyItem.date),
                fullName: historyItem.fullName,
                status: historyItem.status,
                comment: historyItem.comment
            }));
            this.firstHistoryItem = this.historyItems.shift();
        }
    }

    expandText() {
        return this.expanded ? 'less' : 'more';
    }
}

HistoryComponentController.$inject = ['_', 'dateTimeService'];

export default {
    controller: HistoryComponentController,
    bindings: {
        history: '<'
    },
    templateUrl:`app/components/history/history.html`
};


// WEBPACK FOOTER //
// ./app/components/history/history.component.js